import { render, staticRenderFns } from "./LocationItem.vue?vue&type=template&id=0b079964&scoped=true&"
import script from "./LocationItem.vue?vue&type=script&lang=js&"
export * from "./LocationItem.vue?vue&type=script&lang=js&"
import style0 from "./LocationItem.vue?vue&type=style&index=0&id=0b079964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b079964",
  null
  
)

export default component.exports